import { Icon, type IconName } from '#app/components/ui/icon'
import { cn } from '#app/utils/misc'
import { ButtonLink } from '../ui/button'

type PageProps = {
	children: React.ReactNode
	topBar?: PageTopBarProps
	className?: string
}
export function Page({ children, topBar, className }: PageProps) {
	return (
		<div
			data-testid="main-page-container"
			className={cn(
				'container my-6 flex min-h-[90vh] flex-col rounded-lg bg-gradient-to-b from-transparent to-purple-50/30 dark:to-purple-950/10',
				className,
			)}
		>
			{topBar && <PageTopBar {...topBar} />}
			{children}
		</div>
	)
}

type PageTopBarProps = {
	heading: React.ReactNode
	actions?: React.ReactNode
}

function PageTopBar({ heading, actions }: PageTopBarProps) {
	return (
		<div className="mb-4 flex flex-row items-center justify-between gap-2">
			<div>{heading}</div>
			{actions}
		</div>
	)
}

type PageTopBarHeadingProps = {
	icon?: IconName
	heading: string
}

export function PageTopBarHeading({ icon, heading }: PageTopBarHeadingProps) {
	return (
		<div className="flex items-center gap-2">
			{icon && <Icon name={icon} className="h-8 w-8 text-primary" />}
			<h1 className="text-xl font-bold sm:text-3xl">{heading}</h1>
		</div>
	)
}

type PageTopBarButtonLinkIconProps = {
	to: string
	tooltipLabel?: string
	icon: IconName
}

export function PageTopBarButtonLinkIcon({
	to,
	tooltipLabel,
	icon,
}: PageTopBarButtonLinkIconProps) {
	return (
		<ButtonLink
			to={to}
			variant="outline"
			size="icon"
			className="rounded-full"
			tooltipLabel={tooltipLabel}
		>
			<Icon name={icon} />
		</ButtonLink>
	)
}

type PageTopBarBackButtonProps = Omit<PageTopBarButtonLinkIconProps, 'icon'>

export function PageTopBarBackButtonLink({
	to,
	tooltipLabel = 'Back',
}: PageTopBarBackButtonProps) {
	return (
		<PageTopBarButtonLinkIcon
			to={to}
			tooltipLabel={tooltipLabel}
			icon="arrow-left"
		/>
	)
}
